import {
  getDataBlockFieldValue,
  DataBlockWithFields,
} from "@/domains/datablocks/hooks/useDataBlockField";
import { ContentType, DataBlockResponse } from "@/redux/datablocks/types";
import { useDataBlockRelatedData } from "@/domains/datablocks/hooks/useDataBlockRelatedData";

import { BaseUserResponse } from "@/redux/users/types";

export function getEvidenceTitle(
  dataBlock: DataBlockWithFields | undefined,
): string | undefined {
  return getDataBlockFieldValue<string>(dataBlock, "title");
}

export function getEvidenceContributors(
  dataBlock: DataBlockWithFields | undefined,
): number[] {
  return getDataBlockFieldValue<number[]>(dataBlock, "contributors") || [];
}

export function getEvidenceLanguages(
  dataBlock: DataBlockWithFields | undefined,
): number[] {
  return getDataBlockFieldValue<number[]>(dataBlock, "languages") || [];
}

export function useEvidenceContributors(
  dataBlock: DataBlockResponse | undefined,
  options?: { rawValue?: boolean },
) {
  const contributorIds = getEvidenceContributors(dataBlock);

  const { data: contributors, isLoading } = useDataBlockRelatedData(
    contributorIds || [],
    ContentType.Users,
  ) as { data: BaseUserResponse[] | undefined; isLoading: boolean };

  return {
    data: (options?.rawValue ? contributorIds : contributors) || [],
    isLoading,
  };
}
